var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDownThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 12"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "chevron-down-thin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5025",
  fill: "currentColor",
  d: "M0 0h24v12H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33381",
  clipPath: "url(#chevron-down-thin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13124",
  d: "M23.74.327a1 1 0 0 0-1.413-.068L12 9.648 1.672.259a1 1 0 0 0-1.345 1.48l11 10a1 1 0 0 0 1.345 0l11-10A1 1 0 0 0 23.74.327",
  fill: "currentColor"
}))));
export default SvgChevronDownThin;